import QRCode from 'qrcode';

export default class QR {
  constructor(app) {
    this.app = app;

    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
    this.mouseClick = this.mouseClick.bind(this);

    this.init();
  }

  init() {
    this.downloadButtons = document.getElementsByClassName('js-download-qr');

    for (let i = 0; i < this.downloadButtons.length; i += 1) {
      this.downloadButtons[i].addEventListener('click', this.mouseClick);
    }
  }

  destroy() {
    if (this.downloadButtons) {
      for (let i = 0; i < this.downloadButtons.length; i += 1) {
        this.downloadButtons[i].removeEventListener('click', this.mouseClick);
      }

      this.downloadButtons = [];
    }
  }

  mouseClick(event) {
    let name = 'qr';
    const extension = '.jpg';
    let url = window.location.href;
    if (event.currentTarget) {
      if (event.currentTarget.dataset) {
        if (event.currentTarget.dataset.qrName) name = event.currentTarget.dataset.qrName;
        if (event.currentTarget.dataset.qrUrl) url = event.currentTarget.dataset.qrUrl;
      }
    }
    name += extension;

    QRCode.toDataURL(url, { width: 500, height: 500 })
      .then((image) => {
        const tempDownloadLink = document.createElement('a');
        tempDownloadLink.href = image;
        tempDownloadLink.download = name;
        document.body.appendChild(tempDownloadLink);
        tempDownloadLink.click();
        document.body.removeChild(tempDownloadLink);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/qr.js